import request from '@/apis/request'
const resource = 'me' 

export default {
  getWallet: (params = {}) => { 
    return request.get(`${resource}/wallet`, { params })
  }, 
  getCashback: (params = {}) => { 
    return request.get(`${resource}/cashback`, { params })
  }, 
}